module.exports = __webpack_public_path__ + "img/saddle-cloths-17.5ccccfa8.svg";